import { graphql } from "gatsby"
import React from "react"

import Blocks from "../components/Blocks"
import Layout from "../layouts/app"
import { HeadLayout } from "../layouts/head"
import { getTranslationUri } from "../utils/i18n"

function PageTemplate({ data }) {
  const {
    page: {
      pageContent,
      language: { locale },
      translations,
      seo,
      uri,
    },
    location,
  } = data
  const components = pageContent?.components
  return (
    <Layout
      isHomePage
      // location={location}
      locale={locale}
      translationUri={getTranslationUri(translations, locale)}
      seo={seo}
      uri={uri}
      location={location}
      postType="page"
    >
      {components && <Blocks components={components} locale={locale} />}
    </Layout>
  )
}

export function Head({ data }) {
  const {
    page: { seo },
  } = data
  return <HeadLayout seo={seo} />
}
export default PageTemplate

export const pageQuery = graphql`
  query WordPressPage($id: String!) {
    page: wpPage(id: { eq: $id }) {
      ...PageFragment
    }
  }
`
